(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["faqs"] && !Shopify.designMode) return;
  try {
    (function () {
    const accordions = document.querySelectorAll('.block__faq-item--accordion');

    accordions.forEach(function(accordion){

        const thisButton = accordion.querySelector('button');
        const thisContent = accordion.querySelector('.block__faq-item__content');
        const thisContentContainer = accordion.querySelector('.block__faq-item--accordion-content-container');
        thisButton.addEventListener('click', function(){
            let open = thisButton.getAttribute('aria-expanded');

            if(open == 'false'){
                thisButton.setAttribute('aria-expanded', true);
                thisButton.classList.add('open');
                thisContent.classList.remove('hidden');
                thisContent.removeAttribute('hidden');
                thisContent.style.height = (thisContentContainer.offsetHeight + 20) + 'px';
                accordion.classList.add('expanded');
            }else{
                thisButton.setAttribute('aria-expanded', false);
                thisButton.classList.remove('open');
                thisContent.classList.add('hidden');
                thisContent.setAttribute('hidden', '');
                thisContent.style.height = '0px';
                accordion.classList.remove('expanded');
            }
        });

    });

})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["video-modal"] && !Shopify.designMode) return;
  try {
    (() => {
        if (window.SafeOwlVideoModal) return;

        // Delegated from the document so triggers anywhere on the page work, and
        // so blocks re-rendered by the theme editor need no re-binding.
        //
        // showModal() gives focus trapping, Escape-to-close and an inert page
        // behind it natively. The open/close transition is driven by the
        // is-open class: the dialog is shown first, then the class is added so
        // the panel animates in, and on close the class is removed and the
        // dialog only closes once the panel has animated out.

        const OPEN_CLASS = 'is-open';
        const closeTimers = new WeakMap();
        const openers = new WeakMap();
        let pointerDownOutside = false;

        const findModal = (id) => {
            const modal = id ? document.getElementById(id) : null;
            return modal && modal.matches('[data-video-modal]') ? modal : null;
        };

        // A link only opens a modal when it points at this page, e.g. #owly-demo
        // or /pages/about#owly-demo while on /pages/about.
        const hashTarget = (link) => {
            if (!link.hash || link.origin + link.pathname !== location.origin + location.pathname) return null;
            return decodeURIComponent(link.hash.slice(1));
        };

        // Longest transition on the panel, in ms. 0 when reduced motion
        // removes the transitions, so closing is then immediate.
        const transitionTime = (element) => {
            const durations = getComputedStyle(element).transitionDuration.split(',').map(parseFloat);
            return Math.max(0, ...durations) * 1000;
        };

        const open = (modal, opener) => {
            if (!modal) return;

            clearTimeout(closeTimers.get(modal));

            if (!modal.open) {
                const media = modal.querySelector('[data-video-modal-media]');
                const template = modal.querySelector('[data-video-modal-template]');

                if (media && template) {
                    media.replaceChildren(document.importNode(template.content, true));
                }

                openers.set(modal, opener || document.activeElement);
                modal.showModal();

                // Paint the closed state before adding the class, or the
                // browser skips straight to the end of the transition.
                void modal.offsetWidth;

                // Started here, inside the click, so browsers that ignore the
                // autoplay attribute still allow playback with sound.
                const video = modal.querySelector('[data-video-modal-media] video');

                if (video) {
                    video.play().catch(() => {});
                }
            }

            modal.classList.add(OPEN_CLASS);
        };

        const close = (modal) => {
            if (!modal || !modal.open) return;

            const panel = modal.querySelector('[data-video-modal-panel]');

            modal.classList.remove(OPEN_CLASS);
            clearTimeout(closeTimers.get(modal));
            closeTimers.set(modal, setTimeout(() => modal.close(), panel ? transitionTime(panel) : 0));
        };

        // Runs however the dialog closed (button, overlay, Escape, or the
        // browser forcing it shut), so the video always stops and unloads.
        const reset = (modal) => {
            clearTimeout(closeTimers.get(modal));
            modal.classList.remove(OPEN_CLASS);

            const media = modal.querySelector('[data-video-modal-media]');

            if (media) media.replaceChildren();

            const opener = openers.get(modal);
            openers.delete(modal);

            if (opener && opener.isConnected && typeof opener.focus === 'function') {
                opener.focus();
            }
        };

        // Recorded on press so that dragging out of the video (e.g. scrubbing
        // the seek bar) and releasing over the overlay doesn't count as a click
        // outside.
        document.addEventListener('pointerdown', (event) => {
            const modal = event.target.closest('[data-video-modal]');
            pointerDownOutside = Boolean(modal) && !event.target.closest('[data-video-modal-panel]');
        });

        document.addEventListener('click', (event) => {
            const closeButton = event.target.closest('[data-video-modal-close]');

            if (closeButton) {
                close(closeButton.closest('[data-video-modal]'));
                return;
            }

            const openModal = event.target.closest('[data-video-modal]');

            if (openModal) {
                if (pointerDownOutside && !event.target.closest('[data-video-modal-panel]')) {
                    close(openModal);
                }
                pointerDownOutside = false;
                return;
            }

            const trigger = event.target.closest('[data-open-modal], a[href*="#"]');

            if (!trigger) return;

            const id = trigger.hasAttribute('data-open-modal') ? trigger.getAttribute('data-open-modal') : hashTarget(trigger);
            const modal = findModal(id);

            // Not one of ours: leave the click alone for other modals and
            // ordinary anchor links.
            if (!modal) return;

            event.preventDefault();
            open(modal, trigger);
        });

        // Escape: animate out instead of the browser's instant close.
        document.addEventListener('cancel', (event) => {
            if (!event.target.matches('[data-video-modal]')) return;

            event.preventDefault();
            close(event.target);
        }, true);

        document.addEventListener('close', (event) => {
            if (event.target.matches('[data-video-modal]')) reset(event.target);
        }, true);

        window.SafeOwlVideoModal = {
            open: (id) => open(findModal(id)),
            close: (id) => close(findModal(id))
        };
    })();
  } catch(e) { console.error(e); }
})();

})();
